import { useTranslation } from "react-i18next";
import { RotateCcw } from "lucide-react";
import { NeuButton } from "../../../components/neu/Neu";
import { LeavePolicyFields } from "./LeavePolicyFields";

// Branch-level override of the company leave policy.
export const LeaveTab = ({ form, set, setNested, companyPolicy }) => {
  const { t } = useTranslation();
  const overrides = Object.keys(form.leave || {}).length;

  return (
    <div data-testid="branch-leave-tab">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <p className="max-w-xl text-xs font-semibold text-muted-foreground">{t("branches.branchOverrideHint")}</p>
        {overrides ? (
          <NeuButton
            type="button"
            className="flex items-center gap-2 text-xs"
            data-testid="branch-leave-reset"
            onClick={() => set("leave", {})}
          >
            <RotateCcw className="h-4 w-4" /> {t("branches.useCompanyPolicy")}
          </NeuButton>
        ) : null}
      </div>
      <LeavePolicyFields
        value={form.leave || {}}
        defaults={companyPolicy}
        onChange={(key, v) => setNested("leave", key, v)}
      />
    </div>
  );
};
